var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.toasts.length > 0
    ? _c(
        "div",
        { staticClass: "toast-wrapper" },
        [
          _c(
            "transition-group",
            { attrs: { name: "toast-animation", tag: "div" } },
            _vm._l(_setup.toasts, function (toast) {
              return _c(_setup.LFToastComponent, {
                key: toast.id,
                attrs: { toast: toast },
              })
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }